import axios, { AxiosResponse } from "axios";
import i18n from "../../i18n";
import apiClient from "./apiClient";
import Cookies from "js-cookie";
import { AuthResponse } from "../../shared/models/AuthResponse";

// Тип ответа аутентификации


// Функция аутентификации
export const authenticate = async (login: string, password: string): Promise<AuthResponse> => {
  try {
    console.log('Начало аутентификации:', { login });
    const response: AxiosResponse<AuthResponse> = await axios.post(
      `https://order.articool.online/nct/api/v1/auth/login`,
      {
        login,
        password,
      },
      {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        }
      }
    );
    console.log('Успешный ответ от сервера:', response.data);
    return response.data;
  } catch (error: any) {
    console.error("Ошибка при аутентификации:", {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status
    });
    throw error;
  }
};


export const sentEmail = async (email: string): Promise<AuthResponse> => {
  try {
    const response: AxiosResponse<AuthResponse> = await axios.post(
      `https://order.articool.online/nct/api/v1/public/checkEmail`,
      { 
        email: email,
        action:"regestration"
      },
      {
        headers: {
          "Content-Type": "application/json",
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Ошибка при аутентификации:", error);
    throw error;
  }
};

export const verifyEmailApi = async (email: string, code:string): Promise<AuthResponse> => {
  try {
    const response: AxiosResponse<AuthResponse> = await axios.post(
      `https://order.articool.online/nct/api/v1/public/verifyEmail`,
      {
        email: email,
        code: code,
        action:"regestration"
      },
      {
        headers: {
          "Content-Type": "application/json",
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Ошибка при аутентификации:", error);
    throw error;
  }
};




// Функция для обновления refreshToken
export const refreshToken = async (refreshToken: string): Promise<any> => {
  const token = Cookies.get('access_token')
  try {
    const response: AxiosResponse<any> = await axios.post(
      `https://order.articool.online/nct/api/v1/auth/refresh`,
      {
        refreshToken: refreshToken,
      },
      {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
    console.log(response.data,12312321)
    return response.data;
  } catch (error) {
    console.error("Ошибка при обновлении токена:", error);
    throw error;
  }
};


// Функция для выхода из системы (logout)
export const logoutUser = async (refreshToken: string): Promise<void> => {
  try {
    await axios.post(
      `https://order.articool.online/nct/api/v1/auth/logout`,
      {
        refreshToken: refreshToken,
      },
      {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        },
      }
    );
    console.log("Успешный выход из системы");
  } catch (error) {
    console.error("Ошибка при выходе из системы:", error);
    throw error;
  }
};


interface UserRole {
  id: string;
  name: string;
}

interface UserProfileData {
  id: string;
  login: string;
  first_name: string;
  second_name: string;
  last_name: string;
  avatar_pic: string | null;
  date_of_birth: string;
  email: string;
  phone: string;
  roles: UserRole[];
}

interface UserProfileResponse {
  status: number;
  message: string;
  result: UserProfileData;
}

export const getUserInfo = async (): Promise<UserProfileData | null> => {
  console.log('getUserInfo вызван');
  const access_token = Cookies.get('access_token');
  console.log('access_token в getUserInfo:', access_token);
  
  if (!access_token) {
    console.log('access_token отсутствует');
    return null;
  }

  try {
    console.log('Отправка запроса на получение данных пользователя');
    const response = await axios.get<UserProfileResponse>(
      `https://order.articool.online/nct/api/v1/private/user/profile`,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${access_token}`,
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
          Module: `CLOSED_PAGES`,
        }
      }
    );
    console.log('Ответ от сервера:', response.data);
    
    if (!response.data?.result) {
      console.error('Некорректный ответ от сервера:', response.data);
      return null;
    }

    const userData = response.data.result;
    console.log('Структура ответа:', {
      status: response.status,
      hasData: !!response.data,
      dataType: typeof response.data,
      hasResult: !!response.data?.result,
      hasRoles: !!response.data?.result?.roles,
      rolesType: typeof response.data?.result?.roles,
      rolesLength: response.data?.result?.roles?.length,
      roles: response.data?.result?.roles,
      userData: {
        id: userData.id,
        login: userData.login,
        first_name: userData.first_name,
        last_name: userData.last_name,
        email: userData.email,
        phone: userData.phone
      }
    });

    // Проверяем только критически важные поля
    if (!userData.id || !userData.login) {
      console.error('Отсутствуют критические поля в данных пользователя:', userData);
      return null;
    }

    // Если last_name пустое, устанавливаем его как пустую строку
    if (!userData.last_name) {
      userData.last_name = '';
    }

    return userData;
  } catch (error) {
    console.error('Ошибка при получении данных пользователя:', error);
    if (axios.isAxiosError(error)) {
      console.error('Статус ошибки:', error.response?.status);
      console.error('Данные ошибки:', error.response?.data);
      console.error('Заголовки запроса:', error.config?.headers);
      console.error('URL запроса:', error.config?.url);
    }
    return null;
  }
};

// export const getUserInfo = async (): Promise<UserResponse> => {
//   try {
//     // Извлекаем токен из куков
//     const token = Cookies.get("access_token");

//     const response: AxiosResponse<UserResponse> = await axios.get(
//       `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/user/me`,
//       {
//         headers: {
//           "Authorization": `Bearer ${token}`,
//           "Accept": "application/json",
//           "Content-Type": "application/json",
//         }
//       }
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Ошибка при получении информации о пользователе:", error);
//     throw error;
//   }
// };

interface RegistrationRequest {
    login: string;
    password: string;
    confirm_password: string;
    first_name: string;
    last_name: string | null;
    second_name: string;
    mail_code: string;
}

export const registerUser = async (data: RegistrationRequest): Promise<AuthResponse> => {
    try {
        const response: AxiosResponse<AuthResponse> = await axios.post(
            `https://order.articool.online/nct/api/v1/public/registration`,
            data,
            {
                headers: {
                    "Content-Type": "application/json",
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Ошибка при регистрации:", error);
        throw error;
    }
};

// Запрос на отправку кода для восстановления пароля
export const forgotPassword = async (email: string): Promise<AuthResponse> => {
  try {
    const response: AxiosResponse<AuthResponse> = await axios.post(
      `https://order.articool.online/nct/api/v1/public/checkEmail`,
      {
        email: email,
        action: "forgot_password"
      },
      {
        headers: {
          "Content-Type": "application/json",
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Ошибка при отправке кода для восстановления пароля:", error);
    throw error;
  }
};

// Проверка кода для восстановления пароля
export const verifyResetCode = async (email: string, code: string): Promise<AuthResponse> => {
  try {
    const response: AxiosResponse<AuthResponse> = await axios.post(
      `https://order.articool.online/nct/api/v1/public/verifyEmail`,
      {
        email: email,
        code: code,
        action: "forgot_password"
      },
      {
        headers: {
          "Content-Type": "application/json",
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Ошибка при проверке кода восстановления:", error);
    throw error;
  }
};

// Сброс пароля по email и коду
export const resetPassword = async (email: string, code: string, password: string, confirm_password: string): Promise<AuthResponse> => {
  try {
    const response: AxiosResponse<AuthResponse> = await axios.post(
      `https://order.articool.online/nct/api/v1/public/forgot_password`,
      {
        email: email,
        email_code: code,
        password: password,
        confirm_password: confirm_password
      },
      {
        headers: {
          "Content-Type": "application/json",
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Ошибка при сбросе пароля:", error);
    throw error;
  }
};